export default __webpack_public_path__ + "static/media/charizard-box-narrow.a6abc518.png";